// extracted by mini-css-extract-plugin
export default {"editButton":"Item_editButton__rPK6L","labelButton":"Item_labelButton__uXnXK","labelButtonActive":"Item_labelButtonActive__OFYBl","wrapper":"Item_wrapper__efjEg"};